import { useMemo } from "react";
import { useAppState } from "@/modules/app/useAppContext";
import { RelativeComponentLoader } from "@/components/loader";
import { FlexListSummary } from "@/components/listSummary";
import { useSummaryQuery } from "../hooks";
import { getMoneySavings } from "../utils";
import styles from "../styles.module.scss";
import { SummaryItem } from "@/components/listSummary/types";

export const ExplorerSummary = () => {
  const { currency } = useAppState();

  const { data: summaryQueryData, isFetching: isSummaryDataLoading } = useSummaryQuery();

  const summaryDataWithInfo = useMemo(() => {
    if (!summaryQueryData) {
      return [];
    }

    return summaryQueryData.map((item: SummaryItem) => {
      switch (item.label) {
        case "Money Savings":
          item.info =
            "Possible money savings during the selected time period";
          if (
            typeof item.value === "object" &&
            item.value !== null &&
            "min" in item.value &&
            "max" in item.value
          ) {
            item.value = getMoneySavings(item.value.min, item.value.max, currency);
          }
          break;
        case "Time Savings":
          item.info =
            "Possible time savings during the selected time period";
          break;
        default:
          break;
      }
      return item;
    });
  }, [summaryQueryData, currency]);

  return (
    <>
      {isSummaryDataLoading ? (
        <RelativeComponentLoader componentHeight={15} label={"Loading summary..."} />
      ) : (
        <div className={styles.flexListSummary}>
          <FlexListSummary summary={summaryDataWithInfo || []} />
        </div>
      )}
    </>
  );
};
